const Style = {
  // Page Header
  pageHeader: 'flex justify-between items-start mb-6',
  pageTitle: 'text-2xl font-bold text-slate-800',
  pageSubtitle: 'text-sm text-slate-500 mt-1',

  // Tabs
  tabsContainer: 'flex gap-1 mb-6 border-b border-slate-200',
  tab: 'px-4 py-3 text-sm font-medium text-slate-500 cursor-pointer hover:text-slate-700 border-b-2 border-transparent transition-colors',
  tabActive: 'px-4 py-3 text-sm font-medium text-brand-500 cursor-pointer border-b-2 border-brand-500',
  tabCount: 'ml-2 px-2 py-0.5 text-xs bg-slate-100 rounded-full',

  // Plans Grid
  plansGrid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6',

  // Plan Card
  planCard: 'relative bg-white rounded-lg border border-slate-200 p-6 hover:shadow-md transition-shadow',
  planCardHeader: 'flex justify-between items-start mb-4',
  planName: 'text-lg font-semibold text-slate-800',
  planPrice: 'text-2xl font-bold text-slate-800',
  planInterval: 'text-sm text-slate-500',
  planBadge: 'absolute top-4 right-4',
  planFeatures: 'space-y-2 mb-4',
  planFeature: 'flex items-center gap-2 text-sm text-slate-600',
  planFeatureIcon: 'text-green-500',
  planActions: 'flex gap-2 pt-4 border-t border-slate-100',

  // Features Grid
  featuresGrid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6',

  // Feature Card
  featureCard: 'bg-white rounded-lg border border-slate-200 p-4 hover:shadow-md transition-shadow',
  featureCardName: 'text-base font-semibold text-slate-800',
  featureCardKey: 'text-xs text-slate-400 font-mono',
  featureCardHelp: 'text-xs text-slate-500 mt-1',
  featureCardMeta: 'flex flex-wrap gap-2 mt-3',
  featureCardTag: 'flex items-center gap-1 text-xs text-slate-600 bg-slate-50 px-2 py-1 rounded',

  // Feature Editor
  featureEditor: 'space-y-4',
  featureRow: 'flex items-center gap-4 p-3 bg-slate-50 rounded-lg',
  featureInput: 'flex-1',
  featureLimitInput: 'w-20 px-2 py-1 text-sm border border-slate-200 rounded focus:outline-none focus:ring-2 focus:ring-brand-500',
  featureIntervalSelect: 'w-28 px-2 py-1 text-sm border border-slate-200 rounded focus:outline-none focus:ring-2 focus:ring-brand-500 bg-white',
  featureActions: 'flex gap-2',

  // Modules List
  modulesList: 'space-y-2 max-h-96 overflow-y-auto',
  moduleItem: 'flex flex-wrap items-center justify-between p-3 bg-slate-50 rounded-lg gap-2',
  moduleName: 'text-sm font-medium text-slate-700 block',
  moduleKey: 'text-xs text-slate-400 font-mono block',
  moduleLimit: 'text-xs text-slate-500',

  // Settings Panel
  settingsSection: 'mb-8',
  settingsHeader: 'text-lg font-semibold text-slate-800 mb-4',
  settingsGrid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
  settingsCard: 'p-4 bg-slate-50 rounded-lg',
  settingsLabel: 'text-sm font-medium text-slate-600 mb-2 block',
  settingsValue: 'text-lg font-semibold text-slate-800',
  settingsInput: 'w-full p-2 border border-slate-200 rounded focus:outline-none focus:ring-2 focus:ring-brand-500',

  // Add-ons Panel
  addOnsGrid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6',
  addOnCard: 'p-5 bg-white rounded-lg border border-slate-200 hover:shadow-md transition-shadow',
  addOnName: 'text-base font-semibold text-slate-800',
  addOnPrice: 'text-lg font-bold text-green-600',
  addOnMeta: 'text-sm text-slate-500 mt-1',
  addOnTag: 'flex items-center gap-1 text-xs text-slate-600 bg-slate-100 px-2 py-1 rounded',

  // Modal
  modalOverlay: 'fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4',
  modalContent: 'bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col',
  modalHeader: 'flex justify-between items-center px-6 py-4 border-b border-slate-200',
  modalTitle: 'text-xl font-semibold text-slate-800',
  modalBody: 'flex-1 overflow-y-auto px-6 py-4',
  modalFooter: 'flex justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50',

  // Form
  formGroup: 'mb-4',
  formLabel: 'block text-sm font-medium text-slate-600 mb-1',
  formInput: 'w-full p-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500',
  formSelect: 'w-full p-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500 bg-white',

  // Empty State
  emptyState: 'text-center py-12',
  emptyStateText: 'text-slate-500 mb-4',
};

export default Style;